import React from 'react';

import { Text32 } from 'components/layout/text';
import { HolidayScreenContainer } from './elements';
import { CoursePicture } from './icons/course-picture';
import { colorPalette } from 'modules/theme/colorPalettes';
import { Loading } from 'components/loading';

interface IHolidayScreen {
  title?: string | null;
  events?: { id: string; description: string }[];
  loading?: boolean;
}

export const HolidayScreen = ({ title = '', events = [], loading }: IHolidayScreen) => {
  return (
    <HolidayScreenContainer>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Text32 style={{ color: colorPalette.red }}>{title || 'Course closed today'}</Text32>
          {events.map(({ id, description }) => (
            <span key={id}>{description}</span>
          ))}
          <CoursePicture />
        </>
      )}
    </HolidayScreenContainer>
  );
};

